import React, { useState } from "react"
import { useTranslation } from "react-i18next";
import UploadImage from "../upload-image";


const StyleTransfer: React.FunctionComponent<{ image: any, onEnhancedImage: any }> = (props) => {

    const [styleImage, setStyleImage] = useState<any>([]);
    const { t } = useTranslation();


    const UploadImagesHandler = (obj: any) => {

        setStyleImage(obj)
    }

    const Generate = () => {
        const enhanceObj = {
            "id": "",
            "images": [{
                "id": props.image.id,
                "src": props.image.src,
                "ext": props.image.ext
            }],
            "style_image": styleImage,

        }
        props.onEnhancedImage(enhanceObj);
    };


    return (
        <div className="card-F1F5F9">
            <div className="row padd-20">

                <label className="form-label bold-700 mb-3 color-black" htmlFor="selectTypeOpt">{t("roomImageGeneration.uploadPreferredStyle")}</label>
                <UploadImage OnUploadImages={UploadImagesHandler} />

                <div className="d-flex justify-content-end mt-4">
                    <button type="button" className={`button-dash back-746AFF color-FFFFFF bold-600 border-746AFF padd-15 width-auto  ${styleImage.length !== 0 ? '' : 'disabled'}`} onClick={Generate}>{t("roomImageGeneration.generate")}</button>
                </div>
            </div >
        </div>
    )
}
export default StyleTransfer;